import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import App from './App';
import { AuthProvider } from './hooks/useAuth';
import { LocaleProvider } from './lib/i18n';
import './index.css';
import { PageShell } from './components/PageShell';

// honor system dark-mode preference at boot
if (window.matchMedia('(prefers-color-scheme: dark)').matches) {
  document.documentElement.classList.add('dark');
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <LocaleProvider>
      <AuthProvider>
        <PageShell>
          <App />
        </PageShell>
        <Toaster
          position="top-right"
          toastOptions={{
            className: '!bg-white dark:!bg-ink-800 !text-ink-900 dark:!text-ink-50 !shadow-card !border !border-slate-200 dark:!border-ink-700',
            duration: 4000,
          }}
        />
      </AuthProvider>
      </LocaleProvider>
    </BrowserRouter>
  </React.StrictMode>,
);
